// OnboardingRedirect.tsx
import CircularLoader from '@/components/Loaders/CircularLoader';
import CurrentUserContext from '@/Contexts/CurrentUser';
import { useContext } from 'react';
import { Navigate, useLocation } from 'react-router'; // Import useLocation

interface ContextualRouteProps {
  children: React.ReactNode;
}

const OnboardingRedirect: React.FC<ContextualRouteProps> = ({ children }) => {
  const { currentUser, loadingCurrentUser } = useContext(CurrentUserContext);
  const location = useLocation();

  if (loadingCurrentUser) {
    return <CircularLoader />;
  }

  if (location.pathname === '/onboarding') {
    if (currentUser?.basicOnboardingCompleted) {
      return <Navigate to="/" replace />;
    }
    return children;
  }

  if (!currentUser?.basicOnboardingCompleted) {
    return <Navigate to="/onboarding" replace />;
  }

  return children;
};

export default OnboardingRedirect;
